// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__DjkVN","textarea":"TextArea_textarea__2TRVg"};